<template>
    <div class="backgroud-white cs-courseSchedule-editor">
        <div class="text-center">
            <h4>{{ isAdded?'添加': '编辑'}}{{role === 1 ? '老师' : '助教'}}</h4>
        </div>
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form ref="teacherModel" :rules="rules" :model="teacherModel" label-width="100px">
                <el-form-item label="姓名" prop="Name">
                    <el-input @change='checkAllInputs' v-model="teacherModel.Name" class="input-width"></el-input>
                </el-form-item>
                <el-form-item label="国际区号" prop="CountryCode">
                    <el-input @change='checkAllInputs' v-model="teacherModel.CountryCode" class="input-width" maxlength="15"></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="Phone">
                    <el-input @change='checkAllInputs' v-model="teacherModel.Phone" class="input-width" maxlength="15"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="Password">
                    <el-scs-password @change='checkAllInputs' ref="el-scs-password" v-model="teacherModel.password" class="input-width"></el-scs-password>
                </el-form-item>
                <el-form-item label="确认密码" prop="PasswordAgain">
                    <el-scs-password @change='checkAllInputs' ref="el-scs-passwordagain" v-model="teacherModel.passwordAgain" class="input-width"></el-scs-password>
                </el-form-item>
                <el-form-item v-if="!isAdded" id="work-status" label="在职状态">
                    <el-select @change='checkAllInputs' v-model="teacherModel.WorkStatusStr" placeholder="请选择在职状态">
                        <el-option key="0" label="在职" value="在职"></el-option>
                        <el-option key="1" label="离职" value="离职"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col :span="20" v-if="showError">
                    <el-alert :closable="false" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                </el-col>
                <el-col class="footer-right" :span="4">
                    <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="save()">{{ isAdded?'确认添加': '保存更新'}}</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.footer-right {
  float: right;
}
</style>

<script>
import {
  saveTeacherUser,
  getTeacherViewModel
} from "../../service/teacherCourse.service";
import elScsPassword from "../../components/common/el-scs-password";

export default {
  props: {
    isAdded: Boolean,
    teacherId: Number,
    dialogVisible: false,
    role: Number
  },
  data() {
    let validatePassCheck = (rule, value, callback) => {
      if (
        ((this.teacherModel.Password || value) &&
          value !== this.teacherModel.Password) ||
        (this.teacherModel.Password && value !== this.teacherModel.Password)
      ) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      if (value) {
        let isValid = value.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
        );
        if (!isValid) {
          callback(new Error("密码需为8位长度的大小写字母和数字"));
        } else {
          callback();
        }
      }
      callback();
      //  else {
      //     callback(new Error("请输入密码"));
      // }
    };

    let validateName = (rule, value, callback) => {
      let message = "";
      if (!value || value.replace(/(^\s*)|(\s*$)/g, "") == "") {
        message = "请输入姓名";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validatePhone = (rule, value, callback) => {
      let message = "";
      if (value) {
        // if (value.length != 11 && value.length != 10) {
        //   message = "请输入10位或11位数手机号";
        // }
      } else {
        message = "请输入手机号";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      teacherModel: {},
      showError: false,
      errorMessage: "",
      submitBtnClass: "info",
      submitBtnDisable: true,
      submitBtnStatus: {
        status: true,
        stopTime: null,
        resetStatus: function() {
          let self = this;
          clearTimeout(self.stopTime);
          self.stopTime = setTimeout(() => {
            self.status = true;
          }, 1500);
        }
      },
      rules: {
        Name: [
          {
            required: true,
            validator: validateName,
            trigger: "blur"
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur"
          }
        ],
        Phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        Password: [
          {
            //required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        PasswordAgain: [
          {
            // required: true,
            validator: validatePassCheck,
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    elScsPassword
  },
  created() {},
  methods: {
    checkAllInputs(value, onlyCheck) {
      let isValid = true;

      if (!this.$refs["teacherModel"]) return false;

      this.$refs["teacherModel"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });

      if (onlyCheck) return isValid;

      this.submitBtnClass = isValid ? "primary" : "info";
      this.submitBtnDisable = !isValid;

      return isValid;
    },
    save() {
      if (this.submitBtnStatus.status) {
        this.submitBtnStatus.status = false;

        let isValid = this.checkAllInputs(null, true);
        if (!isValid) return false;

        this.teacherModel.Id = this.teacherId;
        if (this.isAdded) {
          this.teacherModel.Id = -1;
        }

        this.teacherModel.WorkStatus = 0;
        if (this.teacherModel.WorkStatusStr == "离职") {
          this.teacherModel.WorkStatus = 1;
        }

        this.teacherModel.Role = this.role;

        let result = saveTeacherUser(this.teacherModel).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.showError = false;
            this.close();
            this.$emit("refreshData");
          }
        });
      }

      this.submitBtnStatus.resetStatus();
    },
    close() {
      this.$refs["teacherModel"].resetFields();
      this.teacherModel = {};
      this.$emit("closeDialog");
      this.showError = false;
      this.errorMessage = "";
    },
    getTeacherViewModel() {
      getTeacherViewModel(this.teacherId).then(result => {
        if (result.success) {
          this.teacherModel = result.data;
          this.initSubmitEnable(this.teacherModel);
        }
      });
    },
    initSubmitEnable(model) {
      if (!!this.$refs["el-scs-password"])
        this.$refs["el-scs-password"].setShowPassword(false);
      if (!!this.$refs["el-scs-passwordagain"])
        this.$refs["el-scs-passwordagain"].setShowPassword(false);
      if (model.Name && model.Phone) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val, oldVal) {
        if (val && this.teacherId > 0) {
          this.getTeacherViewModel();
        }
        if (val && this.teacherId <= 0) {
          this.initSubmitEnable({});
        }
        if (!val) {
          this.close();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/teacherAccount/teacherAddEdit.vue